export const DATABASE = '@LECARTTE';
export const TABLE_RESTAURANT = 'RESTAURANT';
export const ACCESS_TOKEN_KEY = `${DATABASE}:${TABLE_RESTAURANT}:ACCESS_TOKEN`;
export const REFRESH_TOKEN_KEY = `${DATABASE}:${TABLE_RESTAURANT}:REFRESH_TOKEN`;

export const TABLE_CART = 'CART';
export const CART_ITEMS_KEY = `${DATABASE}:${TABLE_CART}:ITEMS`;
